const optional = (obj, path, defaultValue) => {
    if (!obj) return defaultValue;
    if (!path || !path.reduce) return defaultValue;
    
    return path.reduce((xs, x) => (xs && xs[x]) ? xs[x] : defaultValue, obj);
};

export default optional;


// WEBPACK FOOTER //
// ./src/helpers/OptionalAccess.js